export default __webpack_public_path__ + "static/9-64fdf41c9a57769a6480259a9228e8b4.jpg";